

import StockItemPopupTitle from '@/components/StockItem/StockItemPopupTitle'
import CorpSearch from '@/components/Common/UI/Search/CorpSearch'
import Outline from '@/components/Company/Analysis/StockInfo/Outline'
import StockInfo from '@/components/Company/Analysis/StockInfo/'
import StockHistory from '@/components/Company/Analysis/StockHistory/'
import StockThemeChart from '@/components/Company/Analysis/StockThemeChart/'
import { DEFAULT_CODE } from '@/constants/'

import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import api from '~/api'

export default {
    name: 'PopupAnalysis',
    // layout: 'popup_stockItem',
    components: {
        StockItemPopupTitle,
        CorpSearch,
        Outline,
        StockInfo,
        StockHistory,
        StockThemeChart,
    },
    data() {
        return {
            curTab: 0,
            code: DEFAULT_CODE,
            DEFAULT_CODE,
            rcept: [], // 분기보고서   
        }
    },
    computed: {
        ...mapState('search', ['corp']),
    },
    
    created() {
        this.OPEN_POPUP()
        this.$router.replace(this.$route.path) // 22.07.19 suye 임시 uri replace 
    },

    destroyed() {
        this.CLOSE_POPUP()
    },

    mounted() {
        // Default 값
        if (this.$route.query.code) {
            this.code = this.$route.query.code
            this.SearchInfo(this.code)
            this.getRceptNoNm(this.code)
        } else {
            this.SearchInfo(DEFAULT_CODE) // Default 검색값 => 삼성전자
            this.getRceptNoNm(DEFAULT_CODE)
        }
    },

    methods: {
        ...mapActions('search', [
            'GET_CORP_INFO',
            'GET_HISTORY_INFO',
            'GET_THEME_INFO',
            'GET_CORP_PRICE',
        ]),

        ...mapActions('ui', [
            'OPEN_POPUP',
            'CLOSE_POPUP'
        ]),

        SearchInfo(code) {
            this.GET_CORP_INFO(code)
        },
        SearchHistory(code) {
            this.GET_HISTORY_INFO(code)
        },
        SearchTheme(code) {
            this.GET_THEME_INFO(code)
        },
        SearchCorpPrice(code, limit) {
            const params = {
                code,
                limit,
            }
            this.GET_CORP_PRICE(params)
        },
        // 22.07.18 suye 분기보고서 
        async getRceptNoNm(){
            const params = {
                code: this.code,
            }
             const res = await api.getRceptNoNm(params)
            if (res && res.success) {
                if(res.data.rceptList.length > 0){
                    this.rcept = res.data.rceptList[Object.keys(res.data.rceptList)[0]]
                } else {
                    this.recept = []
                }
                // console.log('rcept', this.rcept, this.rcept.length)
            }
        },
        // 분기보고서 
        reportURL(rceptNo){ 
            if(rceptNo) {
                const url = 'http://dart.fss.or.kr//dsaf001/main.do?rcpNo='
                return url+rceptNo
            }
        },
        // 네이버 종목토론실
        naverURL(code){
            if(code){
                const url = 'http://finance.naver.com/item/board.nhn?code='
                return url+code
            } 
        },
        onClick(event) {
            switch (event.target.textContent.trim()) {
                case '종목정보':
                    this.curTab = 0
                    this.SearchInfo(this.code)
                    break
                case '종목히스토리':
                    this.curTab = 1
                    this.SearchCorpPrice(this.corp.code, 180)
                    this.SearchHistory(this.code)
                    break
                case '종목 테마 차트':
                    this.curTab = 2
                    this.SearchCorpPrice(this.corp.code, 180)
                    this.SearchTheme(this.code)
                    break

                default:
                    break
            }
        },
        tabFetch() {
            if (this.Historyswitch) {
                this.SearchHistory(this.code || DEFAULT_CODE)
                this.SearchCorpPrice(this.corp.code, 180)
            }

            if (this.Sectorswitch) {
                this.SearchTheme(this.code || DEFAULT_CODE)
                this.SearchCorpPrice(this.corp.code, 180)
            }
        },
    },
}
